import DataContext from "./DataContext";
import NotificationData from "../data";
import { useEffect, useState } from "react";
const DataContextProvider = (props) => {
  const [
    numberOfUnreadMessages,
    setNumberOfUnreadMessages,
  ] = useState(0);

  let notificationData = {
    reacted: "reacted to your recent post",
    followed: "followed you",
    joined_group: "has joined your group",
    left_group: "left the group",
    private_message: "sent you a private message",
    picture_comment: "commented on your picture",
  };

  useEffect(() => {
    let numberOfUnreadMessages =
      NotificationData.filter(
        (data) => data.unread === true
      );
    setNumberOfUnreadMessages(
      numberOfUnreadMessages.length
    );
  }, []);
  return (
    <DataContext.Provider
      value={{
        NotificationData,
        numberOfUnreadMessages,
        notificationData,
        onReadMessage: () =>
          setNumberOfUnreadMessages(0),
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};

export default DataContextProvider;
